// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3b1Mw","rootSuccess":"CompleteLink_rootSuccess__I7WRp","rootFailure":"CompleteLink_rootFailure__BV8Nv","isDisabled":"CompleteLink_isDisabled__8Tat8"};